var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"banner-link",attrs:{"href":"https://awase-no-awase.colour-field.jp","target":"_blank","rel":"noopener"}})
}
var staticRenderFns = []

export { render, staticRenderFns }